import { Injectable } from '@angular/core';

import { GridDataService } from '../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, OperationType } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { AssignemntAcceptedListingModel, AssignementAcceptedGridParams } from 'common/models/page-models/Assignment Accepted Model/assignment-accepted-params.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';


@Injectable({
    providedIn: 'root'
})
export class AssigmentAcceptedGridDataService extends GridDataService<AssignemntAcceptedListingModel, AssignmentModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.allAssignmentStudentList, http, ss);
    }

    createInstance(): AssignemntAcceptedListingModel {
        return new AssignemntAcceptedListingModel();
    }

   

    override getGridParams(param): GridPostParams {
        let params;
        params = new AssignementAcceptedGridParams();
        params.id = param.id;
        params.sortBy = "invited";
        if(this.ss.slotId){
        params.timeslot_id = param.slot_info[0].timeslot_id;
        }
        else{
            params.timeslot_id = '';
        
        }
        return params;
    }

    override getDataParam() {
        // console.log("DATA PARAMS", this.getDataParam);
        return 'student_info';
    }
    
    override getExtraParam() {
      return 'details';
    }
    getDeleteUrl() {
        return '';
    }

    // override transformDataModel(data: any, param) {
    //     super.transformDataModel(data, param);
    //     console.log(data.details, "dataaaaaa");
      
    //     // Ensure data.details exists and process it
    //     if (data.details && data.details.student_info) {
    //       // Iterate over the student_info array to apply transformations
    //       data.details.student_info.forEach((student) => {
    //         // Set default values for student-related properties if they are null or empty
    //         student.student_ratings = student.student_ratings === "" ? 0 : student.student_ratings;
    //         student.score = student.score !== null && student.score !== undefined ? student.score : "0";
    //         student.student_feedback = student.student_feedback ? student.student_feedback : "NA";
    //         student.trainer_feedback_to_admin = student.trainer_feedback_to_student ? student.trainer_feedback_to_student : "NA";
    //         student.trainer_feedback_to_admin = student.trainer_feedback_to_admin ? student.trainer_feedback_to_admin : "NA";
    //         student.signedUrl_student_file_submit = student.signedUrl_student_file_submit ? student.signedUrl_student_file_submit : "";
    //       });
    //     }
      
    //     return data;
    //   }

    override transformDataModel(data: any, param) {
        super.transformDataModel(data, param);
        // console.log(data.details, "transform data model called");
    
        // Ensure data.details exists and process it
        if (data.details && data.details.student_info) {
            // Iterate over the student_info array to apply transformations
            data.details.student_info.forEach((student) => {
                // Set default values for student-related properties if they are null or empty
                student.student_ratings = student.student_ratings === "" || student.student_ratings === null ? 0 : student.student_ratings;
                student.score = student.score !== null && student.score !== undefined ? student.score : "0";
                student.student_feedback = student.student_feedback ? student.student_feedback : "NA";
                student.trainer_feedback_to_student = (student.trainer_feedback_to_student !== null && student.trainer_feedback_to_student !== "" && student.trainer_feedback_to_student !== undefined) ? student.trainer_feedback_to_student : "NA";
                student.trainer_feedback_to_admin = (student.trainer_feedback_to_admin !== null && student.trainer_feedback_to_admin !== "" && student.trainer_feedback_to_admin !== undefined) ? student.trainer_feedback_to_admin : "NA";
                student.signedUrl_student_file_submit = student.signedUrl_student_file_submit ? student.signedUrl_student_file_submit : "";
            });
            data.student_info = data.details.student_info
            // console.log(data);
            
        }

        // console.log(data, "data after transformation");
        return data;
    }
    
      

}
